import { WorkDay } from "@/core/models";

export class DecimalPrecisionCalculator {

  public static calculate(activeWorkingDay: WorkDay | null | undefined, workingDay?: WorkDay | number | null): number {
    return typeof workingDay === 'number'
      ? workingDay
      : (workingDay?.precisionDecimal ?? activeWorkingDay?.precisionDecimal ?? 4);
  }
}